export default __webpack_public_path__ + "assets/front/scss/collaborative-indexation.e73fbecfabdc7f706d9a8c30020a5d53.css";